import {mainConstants} from '../constants';
import {request} from '../services/request';
import {backendEndpoints} from '../../api';
import {localStorageKeysConstants} from '../../constants';
import {systemHelpers} from '../../utils/helpers';
import {agentChatHistoryHelpers} from '../../utils/helpers/agentChatHistory.helpers';

const errorHandlerProps = {disableAlert: true};

const setLoading = (loading, dispatch) => {
  return dispatch({
    type: mainConstants.SET_LOADING,
    loading
  })
}

const setInitialLoading = (loading, dispatch) => {
  return dispatch({
    type: mainConstants.SET_INITIAL_LOADING,
    loading
  })
}

const setNavigationLoading = (loading) => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.SET_NAVIGATION_LOADING,
      loading
    })
  }
}

const getCurrencies = () => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_CURRENCIES,
      successCallback: (data) => {
        dispatch({
          type: mainConstants.GET_CURRENCIES,
          data: data.sort()
        });
      }
    });
  }
}

const getCategories = () => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSE_CATEGORIES,
      successCallback: (data) => {
        dispatch({
          type: mainConstants.GET_CATEGORIES,
          data: data.sort()
        });
      }
    });
  }
}

const getPermissionMatrix = () => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_PERMISSION_MATRIX,
      successCallback: (data) => {
        dispatch({
          type: mainConstants.GET_PERMISSION_MATRIX,
          data
        });
      },
      errorHandlerProps
    });
  }
}

const collapseNavigationMenu = () => {
  return (dispatch, getState) => {
    const willBeCollapsed = getState().main.isOpenMenu; // toggling from open to collapsed
    localStorage.setItem(localStorageKeysConstants.NAVIGATION_COLLAPSED, String(willBeCollapsed));
    dispatch({
      type: mainConstants.COLLAPSE_NAVIGATION_MENU,
    })
  }
}

const openKycWindow = ({mode, closeIcon = true}) => {
  return (dispatch) => {
    dispatch({
      data: {closeIcon, mode},
      type: mainConstants.OPEN_KYC_WINDOW,
    })
  }
}

const closeKycWindow = () => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.CLOSE_KYC_WINDOW,
    })
  }
}

const openLightKycWindow = () => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.OPEN_LIGHT_KYC_WINDOW,
    })
  }
}

const closeLightKycWindow = () => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.CLOSE_LIGHT_KYC_WINDOW,
    })
  }
}

/**
 * Open the full-width chat.
 *
 * A message or attachments ask something new, so the chat sends them as a new conversation (a chip, the Overview card's
 * composer). An open without them shows the conversation already in memory or, when the page has none, the one
 * remembered from before a reload: its session id goes to the chat to load (see FullWidthAgentChat).
 */
const openFullWidthAgentChat = (message, attachments, reportId) => {
  return (dispatch, getState) => {
    const asksSomethingNew = Boolean(message) || Boolean(attachments?.length);
    const resumeSessionId = asksSomethingNew || getState().main.hasFullWidthAgentChatStarted
      ? null
      : agentChatHistoryHelpers.getRememberedSession(systemHelpers.getAuthDetails().companyId);
    dispatch({
      type: mainConstants.OPEN_FULL_WIDTH_AGENT_CHAT,
      data: {
        message: message || null,
        attachments: attachments?.length ? attachments : null,
        reportId: reportId || null,
        resumeSessionId,
      },
    })
  }
}

/** Leave the full-width chat's conversation for a new one (its New chat button). */
const resetFullWidthAgentChat = () => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.RESET_FULL_WIDTH_AGENT_CHAT,
    })
  }
}

const closeFullWidthAgentChat = () => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.CLOSE_FULL_WIDTH_AGENT_CHAT,
    })
  }
}

const markFullWidthAgentChatStarted = () => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.MARK_FULL_WIDTH_AGENT_CHAT_STARTED,
    })
  }
}

const clearPendingFullWidthAgentChatMessage = () => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.CLEAR_FULL_WIDTH_AGENT_CHAT_PENDING_MESSAGE,
    })
  }
}

export const displayWalletDetailsInitially = () => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.DISPLAY_WALLET_DETAILS_INITIALLY,
    })
  }
}

const setBreadcrumbs = (breadcrumbs) => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.SET_BREADCRUMBS,
      data: breadcrumbs
    })
  }
}

const clearBreadcrumbs = () => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.CLEAR_BREADCRUMBS,
    })
  }
}

const setAvailableModules = (modules = []) => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.SET_AVAILABLE_MODULES,
      data: {modules}
    })
  }
}

const setNavigationMenuProps = (props) => {
  return (dispatch) => {
    dispatch({
      type: mainConstants.SET_NAVIGATION_MENU_PROPS,
      navigationMenuProps: props
    })
  }
}


export const mainActions = {
  collapseNavigationMenu,
  setLoading,
  setInitialLoading,
  getCurrencies,
  getCategories,
  getPermissionMatrix,
  closeKycWindow,
  closeLightKycWindow,
  closeFullWidthAgentChat,
  openKycWindow,
  openLightKycWindow,
  openFullWidthAgentChat,
  resetFullWidthAgentChat,
  markFullWidthAgentChatStarted,
  clearPendingFullWidthAgentChatMessage,
  setAvailableModules,
  setNavigationLoading,
  setNavigationMenuProps,
  displayWalletDetailsInitially,
  setBreadcrumbs,
  clearBreadcrumbs,
};
